import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql, withApollo } from 'react-apollo'
import BillingLayout from 'components/layouts/BillingLayout'
import { BillingReceipt } from './BillingReceipt'
import { BillingEstimate } from './BillingEstimate'

class BillingContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      receipt: null,
    }
  }

  componentDidMount() {
    const { data, client } = this.props

    if (!data.reservation.canShowReceipt) return
    ;(async () => {
      const result = await client.mutate({
        mutation: CREATE_RECEIPT,
        variables: {
          input: {
            reservationUid: data.reservation.uid,
            receiptName: data.company.name,
            fromBusiness: true,
          },
        },
      })

      // canShowReceiptがtrueで、かつreceiptNameに会社名が入っている場合は
      // 仕様上エラーが起こることはない
      if (result.data.createReceipt.userErrors.length)
        throw new Error('user error')
      if (result.data.createReceipt.receipt === null)
        throw new Error('receipt is null')

      this.setState({
        receipt: result.data.createReceipt.receipt,
      })
    })()
  }

  render() {
    const { data } = this.props
    const { receipt } = this.state

    const Component = (() => {
      // 領収書が表示できない場合は見積書の表示
      if (!data.reservation.canShowReceipt) {
        return <BillingEstimate {...this.props} />
      }

      // 領収書のデータが取得出来ている場合は領収書の表示
      if (receipt) {
        return (
          <BillingReceipt
            receipt={{
              reservationId: data.reservation.id,
              reservationStatus: data.reservation.status,
              ...this.state.receipt,
            }}
          />
        )
      }

      // 準備中は何も表示しない
      return null
    })()

    return <BillingLayout {...this.props}>{Component}</BillingLayout>
  }
}

const CREATE_RECEIPT = gql`
  mutation ReceiptPageCreateReceipt($input: CreateReceiptInput!) {
    createReceipt(input: $input) {
      receipt {
        transactionDate
        title
        receiptDetailNumber
        roomName
        planName
        spaceName
        invoiceRegistered
        receiptName
        totalAmountIncludingTax
        ourCompanyName
        ourZipCode
        ourAddress1
        ourAddress2
        ourInvoiceRegistrationNumber
        paymentMethod
        salesTaxAmount
        salesTaxRate
        receiptDetails {
          name
          unitPrice
          quantity
          amountExclusiveOfTax
          amountIncludingTax
        }
      }
      userErrors {
        message
      }
    }
  }
`

const withData = graphql(
  gql`
    query BusinessAccountBillingContainer($username: String!, $uid: String!) {
      company(username: $username) {
        id
        name
      }
      reservation(uid: $uid) {
        canShowReceipt(fromBusiness: true)
        id
        uid
        status
        isLoyalCustomerDiscount
        isLastMinuteDiscount
        planName
        startedAtText(format: "long")
        reservedOptionItems {
          results {
            ... on ReservedOptionItem {
              id
              name
              priceText
              number
              totalAmountText
            }
          }
        }
        reservedOptionFoods {
          results {
            ... on ReservedOptionFood {
              id
              name
              priceText
              number
              totalAmountText
            }
          }
        }
        billing {
          id
          status
          paymentMethod
          paidAt
          paidAtText(format: "long")
          updatedAtText(format: "long")
          guestTotalAmountWithTaxText
          roomAmountText
          guestFeeAmountText
          guestSalesTaxText
          guestFee
          changeAmount
          changeAmountText
          changeDescription
          guestFee
          cancelFee
          refundedAmount
          loyalCustomerDiscountAmountExceptTaxText
          lastMinuteDiscountAmountExceptTaxText
          pointDiscountAmountText
          salesTaxText
          totalPayAmountForUserWithTaxText
          discountAmountText
          guestFeeAmount
          guestPostpayFeeAmount
          guestPostpayFeeAmountText
          isAppliedPoint
          isAppliedCoupon
          refundedAmountText
          extraGuestStayAmount
          extraGuestStayAmountText
          optionCleaningAmount
          optionCleaningAmountText
          weeklyDiscountAmount
          weeklyDiscountAmountText
          monthlyDiscountAmount
          monthlyDiscountAmountText
        }
        room {
          name
        }
        space {
          name
        }
      }
    }
  `,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
        uid: props.match.params.uid,
      },
    }),
  },
)(BillingContainer)

function mapStateToProps(state) {
  return state
}
export default withRouter(connect(mapStateToProps)(withApollo(withData)))
